import { css, ThemeContext } from '@emotion/react';
import styled from '@emotion/styled';
import { useEffect, useState, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useUID } from 'react-uid';

import { AppTheme } from 'theme';

import { emitter } from 'graphql/links/error';
import colors from 'lib/colors';

import Button from './Button';
import Flex from './Flex';
import Modal from './Modal';

const SessionTimeoutDialog = () => {
  const [opened, setOpened] = useState(false);

  const theme = useContext(ThemeContext) as AppTheme;
  const IS_EDU = theme?.layout?.edu;

  useEffect(() => {
    const listener = () => {
      setOpened(true);
    };
    emitter.addListener('unauthenticated', listener);
    return () => {
      emitter.removeListener('unauthenticated', listener);
    };
  }, []);

  const [t] = useTranslation();
  const modalHeadingId = useUID();

  const handleClick = () => {
    // Do normal browser navigation, because we want to download new app version if any.
    // Also don't use <a> tag because this ain't a link, user needs to click this to do anything else in this window
    window.location.replace('/login');
  };

  return (
    <Modal
      isOpen={opened}
      shouldCloseOnOverlayClick={false}
      shouldCloseOnEsc={false}
      aria={{
        labelledby: modalHeadingId,
      }}
      css={css`
        .Overlay {
          z-index: 10;
        }
        .Modal {
          background-color: white;
          min-width: 350px;
        }
      `}
    >
      <Flex p={4} flexDirection="column" alignItems="center">
        <Heading id={modalHeadingId}>
          {t('sessionTimeoutDialog.title', 'Byli jste odhlášeni')}
        </Heading>
        <BodyText>
          {t(
            'sessionTimeoutDialog.text',
            'Z důvodu neaktivity, jste byli odhlášeni',
          )}
        </BodyText>
        <Button
          onClick={handleClick}
          extraWide
          variant={IS_EDU ? 'primary' : 'warning'}
          labelT={{
            key: 'sessionTimeoutDialog.button',
            defaultValue: 'Jít na přihlášení',
          }}
        />
      </Flex>
    </Modal>
  );
};

export default SessionTimeoutDialog;

const Heading = styled.h1`
  font-weight: bold;
  font-size: 30px;
  color: ${colors.black};
  letter-spacing: 0.46px;
  margin: 0;
`;

const BodyText = styled.p`
  font-size: 1rem;
  color: ${colors.gray};
  padding: 0;
  margin: 0;
  margin-bottom: 24px;
  margin-top: 24px;
`;
